import { useSelector } from 'react-redux';
import { getFullname } from 'shared/helpers/common';
import SignOutButton from './SignOutButton';

export default function SettingsMenu() {
  const { userData } = useSelector((state) => state.currentUser);
  const { first: firstName, last: lastName } = userData?.fullName || {};

  return (
    <div className="bg-white absolute right-0 mr-4 w-52 rounded-lg">
      <div>
        <div className="mt-2 font-bold px-5 py-3 border-b">
          {getFullname({ firstName, lastName })}
        </div>
        <ul className="pt-3">
          <li className="px-5 pb-3 pt-2 hover:bg-default-hover">
            <SignOutButton className="w-full" />
          </li>
        </ul>
      </div>
    </div>
  );
}
